export default {
  title: '普通制作',
  content: '您可基于模板新建作品，并灵活调整资产和参数。',
  dco: {
    title: 'DCO制作（Dynamic Creative Optimization）',
    content:
      'DCO制作是一种支持广告智能投放能力的制作方式，其产出的一个包体可千人千面展示不同的内容。您可以针对我们开放的位置添加备选资产，将作品推送至 SS 对应的账户加入投放计划后，Mintegral将会依据算法在每一个位置挑选出优选资产进行组合，提升转化。',
    tips: '通常用于描述动态广告素材，Mintegral会根据机器学习组合素材元素，以便于进行广告展示来达到优化素材与提升转化的目的。',
  },
  multi: {
    title: '多组合版本',
    content:
      '多组合制作是一种高效批量制作方式，可同时产出多个作品进行AB测试。您可以为需要调整的位置添加资产，一次性下载所有排列组合的作品（最多27个组合）',
  },
  is_optimiz: {
    label: '换肤编辑',
    yes: '支持换肤编辑',
    no: '不支持换肤编辑',
  },
  emptyList: '暂无数据',
  previewButtonText: '预览',
  editButtonText: '编辑版本',
  createButtonText: '新建项目',
  versionGuideText: '个版本',
  templateListHeaderText: {
    ProductInfo: '创意方向名称及ID',
    VersionCount: '项目数量',
    Network: '渠道',
    NetworkTips: '配置仅支持Mintegral渠道',
    Platform: '平台',
    Language: '语言',
    Lastedittime: '最后编辑时间',
    Creationtime: '项目交付时间',
    versionCreatedTime: '项目创建时间',
    Options: '操作',
  },
  options: {
    version: '项目管理',
    dco: 'DCO 版本管理',
    multi: '多组合配置',
    preview: '预览',
    report: '查看数据',
  },
  order: {
    ascending: '点击升序',
    descending: '点击降序',
  },
  search: '搜索Playable',
  DatePicker: {
    Starttime: '开始时间',
    to: '至',
    Endtime: '结束时间',
  },
  empty: {
    NoResults: '未找到相关结果',
    msg: '抱歉，没有找到符合条件的结果，建议更换不同的搜索条件。',
    back: '返回全部',
    text: '版本列表为空',
    textTip: '点击下方按钮，立即新建版本',
    listEmpty: '当前列表为空',
    listEmptyMsg: '尚未开启此项服务，如有需求',
    listEmptySubMsg: '可发邮件至support@mindworks-creative.com',
  },
}
